import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FirebaseService } from '../core/services/firebase.service';
import { OrgContextService } from '../core/services/org-context.service';

export function requireOrg(): CanActivateFn {
  return async () => {
    const orgContext = inject(OrgContextService);
    const firebase = inject(FirebaseService);
    const router = inject(Router);

    // On a hard refresh the org may not be restored yet (init waits for auth
    // readiness). Ensure it's loaded before deciding — otherwise routes that
    // run requireOrg alongside the auth guard (e.g. the full-screen storyboard
    // workspace) bounce to /new → home on reload.
    if (!orgContext.currentOrg()) {
      await orgContext.init().catch(() => undefined);
    }
    // Data residency: the org exists but its region can't be reached — say so
    // instead of bouncing to onboarding or falling back to another org.
    if (firebase.regionError()) return router.parseUrl('/region-unavailable');
    return orgContext.currentOrg() ? true : router.parseUrl('/new');
  };
}
